import { createSlice } from '@reduxjs/toolkit'

const getDefaultOptions = () => ({
  message: '',
  type: 'info',
  icon: '',
  width: '300px',
  dismissible: false,
  timeout: 3000,
  visible: true
})

const notificationSlice = createSlice({
  name: 'notification',
  initialState: {
    notifications: []
  },
  reducers: {
    ADD_NOTIFICATION: (state, action) => {
      state.notifications.push(action.payload)
    },
    DELETE_NOTIFICATION: (state, action) => {
      const index = state.notifications.findIndex((notification) => notification.id === action.payload.id)
      if (index !== -1) {
        state.notifications.splice(index, 1)
      }
    }
  }
})

export const { ADD_NOTIFICATION, DELETE_NOTIFICATION } = notificationSlice.actions

/**
 * @param {Object} options
 * @param {string} [options.message]
 * @param {string} [options.type]
 * @param {string} [options.icon]
 * @param {string} [options.width='480px']
 * @param {boolean} [options.dismissible=false]
 * @param {number} [options.timeout=3000]
 */
export const notify = (options) => (dispatch) => {
  const notification = { ...getDefaultOptions(), ...options, id: Date.now() }

  dispatch(ADD_NOTIFICATION(notification))

  setTimeout(() => {
    dispatch(DELETE_NOTIFICATION({ id: notification.id }))
  }, notification.timeout || 1000)
}

export default notificationSlice.reducer
